import qs from 'querystring';

import { omitBy } from 'lodash';

import { checkIfMfo } from '@sravni/ugc/lib/utils/checkOrganizationsType';

import * as constants from '../constants/reviews';
import { FILTER_NAMES, UNNECESSARY_FILTERS } from '../constants/reviews';
import {
  LIST,
  ORGANIZATION_LIST,
  ORGANIZATION_LIST_MFO,
  PRODUCT_LIST,
  SPECIFIC_PRODUCT_LIST,
} from '../constants/routes';

const paramRegExp = /(:[^\/&\?]*\??)(\/|$)/g;

export const removeDefaultsProperties = (target, defaults) => {
  target = { ...target };

  Object.keys(target).forEach((key) => {
    // if (key === 'region') {
    //   target.locationRoute = target[key].route;
    //   target.regionId = target[key].id;
    //   delete target[key];
    // }
    // if (key !== 'rated' && target[key] === defaults[key]) {
    //   delete target[key];
    // }
    if (target[key] === defaults[key] || target[key] === UNNECESSARY_FILTERS[key]) {
      delete target[key];
    }
  });

  return target;
};

export const splitProperties = (isLeft, obj) =>
  Object.entries(obj).reduce(
    ([left, right], [k, v]) => (isLeft(v, k) ? [{ ...left, [k]: v }, right] : [left, { ...right, [k]: v }]),
    [{}, {}],
  );

export const toString = (params: Record<string, any>, prefix = '?') => {
  const queryString = qs.stringify(params);

  return queryString ? prefix + queryString : '';
};

export const replaceWithParams = (pattern, params) =>
  Object.keys(params)
    .reduce(
      (acc, param) =>
        // acc.replace(new RegExp(`:${escapeRegExp(param)}\\??(?=(\\/|$|\\?))`), params[param]),
        acc.replace(`:${param}`, params[param]),
      pattern,
    )
    .replace(paramRegExp, '');

export const addInitialSlash = (str) => (str.match(/^\//) ? str : `/${str}`);

interface ILinkParams {
  queryParams?: Record<string, any>;

  [name: string]: any;
}

export const createLinkProps = (page: string = '', pattern: string = '', params: ILinkParams = {}) => {
  const [
    inlineParams,
    {
      // @ts-ignore
      queryParams = {},
      ...restParams
    },
  ] = splitProperties((_, key) => pattern.match(`:${key}`), params);

  return {
    ...restParams,
    href: `${addInitialSlash(page)}${toString({ ...queryParams, ...inlineParams })}`,
    as: `${replaceWithParams(pattern, inlineParams)}/${toString(queryParams)}`,
  };
};

export const EXCLUDED_QUERY_PROPS = [
  FILTER_NAMES.TYPE,
  'organization',
  FILTER_NAMES.PRODUCT,
  FILTER_NAMES.SPECIFIC_PRODUCT,
  FILTER_NAMES.ORGANIZATION,
  FILTER_NAMES.REVIEWOBJECTTYPE,
  FILTER_NAMES.FINGERPRINT,
];

export const createUrlWithFilters = (filters, query) => {
  const queryParams = removeDefaultsProperties(
    {
      ...query,
      ...filters,
    },
    { ...constants.DEFAULT_FILTERS },
  );

  const qpClear = omitBy(
    queryParams,
    (value, key) => EXCLUDED_QUERY_PROPS.map((prop) => prop.toLowerCase()).includes(key.toLowerCase()) || !value,
  );

  const isMfo = checkIfMfo(query.type);
  const organizationRoute = isMfo ? ORGANIZATION_LIST_MFO : ORGANIZATION_LIST;

  let pageType = LIST;

  if (query.specificProduct) {
    pageType = SPECIFIC_PRODUCT_LIST;
  } else if (query.product) {
    pageType = PRODUCT_LIST;
  } else if (query.organization) {
    pageType = organizationRoute;
  }

  return createLinkProps('/list', pageType, {
    type: query.type,
    organization: query.organization,
    product: query.product,
    specificProduct: query.specificProduct,
    queryParams: qpClear,
  });
};
